import React from 'react'
import Navbar from '../Navbar/Navbar'
import Footer from '../Footer/Footer'
import AboutOne from './AboutOne'
import AboutTwo from './AboutTwo'
import AboutThree from './AboutThree'

const AboutMain = () => {
  return (
    <div><Navbar/>
    <AboutOne/>
    <AboutTwo/>
    {/* <AboutThree/> */}
    <Footer/>
    </div>
  )
}

export default AboutMain